import Vue from 'vue'
import { URL_USER, URL_USER_SUBSCRIPTIONS } from '@/constants/urls.js'
import { CURRENT_USER, ACCOUNT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [CURRENT_USER.STATE.EMAIL]: null,
  [CURRENT_USER.STATE.PHONE]: null,
  [CURRENT_USER.STATE.HASH]: null,
  [CURRENT_USER.STATE.CONTACT_PERSON]: null,
  [CURRENT_USER.STATE.SUBSCRIPTIONS_STATUS]: null,
  [CURRENT_USER.STATE.USER_ID]: null,
  [CURRENT_USER.STATE.ORGANIZATION_ID]: null,
  [CURRENT_USER.STATE.SUBSCRIPTIONS]: null,
  [CURRENT_USER.STATE.PARTICIPANT_TYPE]: null
}

const actions = {
  async [CURRENT_USER.ACTIONS.GET_CURRENT_USER_INFO] ({ dispatch, commit, rootState }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    const accountParticipantType = rootState.account.participantType
    const userParticipantType = resp.data.participantType

    commit(CURRENT_USER.MUTATIONS.GET_CURRENT_USER_INFO, resp.data)
    // если с информацией о пользователе пришел измененный ParticipantType
    // то перезаписываем его в localStorage
    if (accountParticipantType !== userParticipantType) {
      await dispatch(`${ACCOUNT.NAMESPACE}/${ACCOUNT.ACTIONS.UPDATE_PARTICIPANT_TYPE}`, userParticipantType, { root: true })
    }
  },
  async [CURRENT_USER.ACTIONS.GET_CURRENT_USER_SUBSCRIPTION] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_USER_SUBSCRIPTIONS}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(CURRENT_USER.MUTATIONS.GET_CURRENT_USER_SUBSCRIPTION, resp.data)
  },
  async [CURRENT_USER.ACTIONS.CHANGE_CURRENT_USER_SUBSCRIPTION] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_USER_SUBSCRIPTIONS}`,
      model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [CURRENT_USER.ACTIONS.CLEAR_CURRENT_USER_SUBSCRIPTION] ({ commit }) {
    commit(CURRENT_USER.MUTATIONS.CLEAR_CURRENT_USER_SUBSCRIPTION)
  },
  async [CURRENT_USER.ACTIONS.CLEAR_CURRENT_USER_INFO] ({ commit }) {
    commit(CURRENT_USER.MUTATIONS.CLEAR_CURRENT_USER_INFO)
  }
}

const mutations = {
  [CURRENT_USER.MUTATIONS.GET_CURRENT_USER_INFO] (state, info) {
    state[CURRENT_USER.STATE.EMAIL] = info.email
    state[CURRENT_USER.STATE.PHONE] = info.phone
    state[CURRENT_USER.STATE.HASH] = info.hash
    state[CURRENT_USER.STATE.CONTACT_PERSON] = info.contactPerson
    state[CURRENT_USER.STATE.SUBSCRIPTIONS_STATUS] = info.subscriptionsStatus
    state[CURRENT_USER.STATE.USER_ID] = info.userId
    state[CURRENT_USER.STATE.ORGANIZATION_ID] = info.organizationId
    state[CURRENT_USER.STATE.PARTICIPANT_TYPE] = info.participantType
  },
  [CURRENT_USER.MUTATIONS.GET_CURRENT_USER_SUBSCRIPTION] (state, model) {
    state[CURRENT_USER.STATE.SUBSCRIPTIONS] = model
  },
  [CURRENT_USER.MUTATIONS.CLEAR_CURRENT_USER_SUBSCRIPTION] (state) {
    state[CURRENT_USER.STATE.SUBSCRIPTIONS] = null
  },
  [CURRENT_USER.MUTATIONS.CLEAR_CURRENT_USER_INFO] (state) {
    state[CURRENT_USER.STATE.EMAIL] = null
    state[CURRENT_USER.STATE.PHONE] = null
    state[CURRENT_USER.STATE.HASH] = null
    state[CURRENT_USER.STATE.CONTACT_PERSON] = null
    state[CURRENT_USER.STATE.SUBSCRIPTIONS_STATUS] = null
    state[CURRENT_USER.STATE.USER_ID] = null
    state[CURRENT_USER.STATE.ORGANIZATION_ID] = null
    state[CURRENT_USER.STATE.PARTICIPANT_TYPE] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
